import React, { useState } from "react"
import { graphql } from "gatsby"
import { Typography } from "antd"
import Layout from "../../components/Layout"
import "../../styles/odooServices.scss"
import "../../styles/services.scss"

import News from "../../components/News"
import OdooTopSection from "../../components/OdooTopSection"
import WhyChooseVisiomateforD365 from "../../components/WhyChooseVisiomateforD365"
import RecentSuccessStories from "../../components/RecentSuccessStories"
import Wethoughtyoumighthavequestions from "../../components/Wethoughtyoumighthavequestions"
import ServiceCard from "../../components/ServiceCard"
import InfoModal from "../../components/InfoModal"

import img1 from "../../images/Odoo/MMG-01.png"
import img2 from "../../images/Odoo/UnitedGulf-01.webp"
import IconsAdded from "../../components/IconsAdded"
import SimplifiedSteps from "../../components/SimplifiedSteps"
import Simplified_div from "../../components/Simplified_div"

import sc_performance from "../../images/servicecard/performance.png"
import sc_testing     from "../../images/servicecard/Automated testing.png"
import sc_integration from "../../images/servicecard/integration.png"
import sc_cloud       from "../../images/servicecard/cloud.png"
import sc_deployment  from "../../images/servicecard/deployment.png"
import sc_ecommerce   from "../../images/servicecard/E-commerce.png"

import odooImg1 from "../../images/D365/walkerssk-advisor-9652579_1920.jpg"
import odooImg2 from "../../images/D365/aymanejed-laptop-3196481_1920.jpg"
import odooImg3 from "../../images/D365/stocksnap-people-2569234_1920.jpg"
import odooImg4 from "../../images/D365/bertholdbrodersen-consulting-3031678_1920.jpg"
import odooImg5 from "../../images/D365/ayaanaabhi-work-8049516_1920.jpg"

const { Title } = Typography

const benefitSlides = [
  {
    img: odooImg1,
    heading: "A Partner Who Knows Odoo Inside Out",
    text: "You get certified Odoo consultants who have delivered implementations across industries — not generalists learning on your project. Our team brings deep module knowledge, customisation experience, and implementation methodology to every engagement.",
  },
  {
    img: odooImg2,
    heading: "Implementation That Fits Your Timeline",
    text: "We work to your business calendar, not a rigid project template. Whether you need a phased rollout across departments or a complete go-live within a defined window, our project management keeps delivery on track without disrupting daily operations.",
  },
  {
    img: odooImg3,
    heading: "Integrations That Just Work",
    text: "Odoo is most powerful when it talks to the rest of your stack. We design and build integrations with your existing systems — accounting, e-commerce, logistics, HR, and more — so data flows accurately and automatically across your business.",
  },
  {
    img: odooImg4,
    heading: "Support Beyond Go-Live",
    text: "Implementation doesn't end at go-live. We provide post-launch support, user adoption monitoring, and proactive system optimisation — so your Odoo environment keeps pace with your business as it evolves.",
  },
  {
    img: odooImg5,
    heading: "Your Business, Your Configuration",
    text: "Off-the-shelf ERP rarely fits perfectly. We tailor Odoo's modules, workflows, and reporting to match exactly how your business operates — reducing workarounds, improving adoption, and delivering an ERP that feels built for you.",
  },
]

const Index = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isModalVisible, setIsModalVisible] = useState(false)

  return (
    <div className="Odoo">
      <Layout pageTitle={"Visiomate - Odoo Implementation Partner"}
      descrip = {"Tailor Odoo to your unique business needs. Our implementation partners provide customized solutions and ongoing support for long-term success."}>
        <OdooTopSection
          headerData={{
            title: "Implement Odoo With Confidence — Certified Partners, Proven Results",
            para: "From requirements analysis to go-live and beyond, Visiomate delivers tailored Odoo implementations that fit your exact business processes — backed by certified expertise, hands-on support, and a commitment to your long-term success.",
          }}
          data={data}
        />
        <div className="services-page-container position-relative">
          <div className="services-description-section">
            <div className="service-heading-and-detail">
              <Title>Why Businesses Choose Visiomate for Odoo Implementation</Title>
            </div>
            <div className="service-cards-wrapper">
              <ServiceCard
                img_src={sc_performance}
                img_alt="Certified Odoo implementation"
                card_heading="Certified Odoo Implementation"
                card_para="End-to-end implementation from requirements analysis to go-live. We configure, customise, and deploy Odoo to align precisely with your business processes — with a structured methodology that reduces risk and accelerates time-to-value."
              />
              <ServiceCard
                img_src={sc_testing}
                img_alt="Odoo custom module development"
                card_heading="Custom Module Development"
                card_para="Extend Odoo beyond its standard capabilities with custom modules built exactly to your specifications. Our developers build, test, and document every customisation to ensure long-term maintainability and upgrade compatibility."
              />
              <ServiceCard
                img_src={sc_integration}
                img_alt="Odoo third-party integrations"
                card_heading="Third-Party Integrations"
                card_para="Connect Odoo with your existing systems — e-commerce platforms, payment gateways, logistics providers, HR tools, and more. We design robust integration architectures that keep data accurate and workflows uninterrupted."
              />
              <ServiceCard
                img_src={sc_cloud}
                img_alt="Odoo data migration"
                card_heading="Seamless Data Migration"
                card_para="Migrate your data from legacy systems, spreadsheets, or other ERPs with confidence. We handle data mapping, cleansing, validation, and import — ensuring your historical records arrive in Odoo accurately and completely."
              />
              <ServiceCard
                img_src={sc_deployment}
                img_alt="Odoo user training"
                card_heading="User Training & Change Management"
                card_para="A successful implementation depends on adoption. We deliver role-specific training, user acceptance testing support, and change management guidance — so your team is ready, confident, and productive from day one."
              />
              <ServiceCard
                img_src={sc_ecommerce}
                img_alt="Odoo post go-live support"
                card_heading="Post Go-Live Support & Optimisation"
                card_para="Our relationship doesn't end at go-live. We provide structured post-launch support, monitor system performance, address user issues, and continuously optimise your Odoo environment as your business evolves."
              />
            </div>
          </div>
        </div>
        <div className="d365-feature-strip">
          <span>Certified Odoo Partner</span>
          <span>Custom Modules</span>
          <span>Data Migration</span>
          <span>Third-Party Integrations</span>
          <span>User Training</span>
          <span>Post Go-Live Support</span>
          <span>Business Process Mapping</span>
          <span>Odoo Community Edition</span>
        </div>
        <div className="d365-benefits-section">
          <div className="d365-benefits-intro">
            <Title>
              What You Gain With <strong>Odoo Implementation</strong> From Visiomate
            </Title>
            <p>
              Our Odoo implementations are built around one goal: an ERP that fits your business exactly — configured to your processes, integrated with your systems, and supported by a team invested in your long-term success.
            </p>
          </div>
          <div className="d365-carousel-wrapper">
            <button
              className="d365-arrow d365-arrow-prev"
              onClick={() => setCurrentSlide((currentSlide - 1 + benefitSlides.length) % benefitSlides.length)}
              aria-label="Previous slide"
            >
              &#8592;
            </button>
            <div className="d365-slide">
              <div className="d365-slide-text">
                <h3>{benefitSlides[currentSlide].heading}</h3>
                <p>{benefitSlides[currentSlide].text}</p>
              </div>
              <div
                className="d365-slide-img"
                style={{ backgroundImage: `url(${benefitSlides[currentSlide].img})` }}
              />
            </div>
            <button
              className="d365-arrow d365-arrow-next"
              onClick={() => setCurrentSlide((currentSlide + 1) % benefitSlides.length)}
              aria-label="Next slide"
            >
              &#8594;
            </button>
          </div>
          <div className="d365-carousel-dots">
            {benefitSlides.map((_, i) => (
              <button
                key={i}
                className={`d365-dot${i === currentSlide ? " active" : ""}`}
                onClick={() => setCurrentSlide(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
        <div className="position-relative">
        {/* <WhyChooseVisiomateforD365
          data={{
            title: "Why Choose Visiomate for Odoo?",
            headings: [
              {
                heading: "Crafting Tailored Solutions",
                description:
                  "At Visiomate, our seasoned professionals recognize the distinctiveness of every business. We pride ourselves on developing bespoke Odoo solutions meticulously crafted to harmonize seamlessly with your organization's goals and processes.",
              },
              {
                heading: "Seamless End-to-End Implementation",
                description:
                  "From the drawing board to flawless execution, our comprehensive Odoo implementation services pave the way for a seamless transition. Unlock the full potential of Odoo robust platform, empowering your business for success.",
              },
              {
                heading: "Proactive Support at Every Turn",
                description:
                  "Our commitment goes beyond implementation. We stand steadfast by your side with proactive support services. Our dedicated team ensures the continuous seamless operation of your Odoo environment, offering timely assistance, updates, and a commitment to ongoing improvements.",
              },
              {
                heading: "Navigating Industries with Expertise",
                description:
                  "With a diverse portfolio spanning the apparel and footwear sector, Visiomate brings a wealth of industry-specific knowledge to the table. Whether you're dealing with fashion trends, inventory management, or supply chain intricacies, our expertise is tailored to elevate your operations.",
              },
            ],
          }}
          dataFormImages={data}
        /> */}
        {/* <IconsAdded iconColor={"yellow"}/> */}
        </div>
        <div className="position-relative">
        <RecentSuccessStories
          data={{
            title: "Recent Success Stories ",
            Text: [
              {
                description:
                  "Muscat Media Group required a fully automated HR Management system mapped with their business needs, we provided them a solution using Odoo.",
                image: img1
              },
              {
                description:
                  "Visiomate team provided a solution for multi-step manufacturing process to United Gulf Pipe Manufacturing Co. LLC (UGPM)",
                image: {img2}
              },
            ],
          }}
          dataFormImages={data}
        />
        {/* <IconsAdded/> */}
        </div>
        {/* <OdooSimplifiedStepstogetyouStarted /> */}
        {/* <SimplifiedSteps iconsColor="yellow">
            <Simplified_div headingNo='01' heading='User-Friendly Ticketing System' showButton={true}>
              <li>Ensure the system captures essential details like severity, category, and a brief description.</li>
            </Simplified_div>
            <Simplified_div headingNo='02' heading='Priority Assignment'>
              <li>Assign priority levels to tickets based on their impact on business operations. </li>
              <li>Critical issues should be addressed with urgency, while routine queries can follow a standard timeline.</li>
            </Simplified_div>
            <Simplified_div headingNo='03' heading='Clear Communication Channels'>
              <li>Provide clear communication channels for users to interact with the support team. </li>
              <li>This can include a dedicated support portal, email, and a helpline, ensuring users can choose the most convenient option.</li>
            </Simplified_div>
            <Simplified_div headingNo='04' heading='Root Cause Analysis'>
              <li>Perform root cause analysis for recurring issues to address underlying problems and prevent future occurrences. </li>
              <li>This proactive approach contributes to long-term system stability.</li>
            </Simplified_div>
            <Simplified_div headingNo='05' heading='Regular Status Updates'>
              <li>Keep users informed about the status of their tickets with regular updates. </li>
              <li>Even if there's no resolution yet, proactive communication fosters trust and transparency.</li>
            </Simplified_div>
            <Simplified_div headingNo='06' heading='User Feedback Loop'>
              <li>Establish a feedback loop to gather input from users about their support experiences. </li>
              <li>Use this feedback to identify areas for improvement and refine the support process.</li>
            </Simplified_div>
            <Simplified_div headingNo='07' heading='Post-Resolution Follow-up'>
              <li>Conduct post-resolution follow-ups with users to ensure their issues are fully resolved and gather insights for further improvements. </li>
              <li> This step enhances user satisfaction and loyalty.</li>
            </Simplified_div>
            <Simplified_div headingNo='08' heading='Continuous Training for Support Team'>
              <li>Ensure the support team undergoes continuous training to stay updated on the latest Dynamics 365 features, updates, and best practices. </li>
              <li>This empowers them to provide expert assistance.</li>
            </Simplified_div>
          </SimplifiedSteps> */}
        <Wethoughtyoumighthavequestions
          data={[
            {
              question: "What is Odoo?",
              answer:
                "Odoo is an open-source suite of integrated business applications designed to help companies manage various aspects of their operations, including CRM, sales, inventory, manufacturing, accounting, HR, and more. It offers a modular approach, allowing organizations to select and customize the modules that best fit their needs.",
              answer1: "",
              answer2: "",
              answer3: "",
              answer4: "",
              answer5: "",
              answer6: "",
              answer7: "",
              answer8: "",
              answer9: "",
            },
            {
              question:
                "Why should I consider implementing Odoo for my business?",
              answer: "Implementing Odoo offers several benefits, including:",
              answer1:
                "- Comprehensive Suite: Access to a wide range of integrated business applications covering various functional areas, reducing the need for multiple disparate systems.",
              answer2:
                "- Scalability: Odoo is scalable and flexible, allowing organizations to start with a few modules and expand as their business grows or requirements change.",
              answer3:
                "- Cost-Effective: As an open-source solution, Odoo offers a lower total cost of ownership compared to proprietary software, with no licensing fees and affordable implementation and customization options.",
              answer4:
                "- Customization: Odoo can be customized to meet specific business requirements, with the ability to add or modify modules, workflows, reports, and user interfaces.",
              answer5:
                "- Community and Support: Access to a vibrant community of users, developers, and partners for knowledge sharing, collaboration, and support.",
              answer6: "",
              answer7: "",
              answer8: "",
              answer9: "",
            },
            {
              question: "What modules are included in Odoo?",
              answer:
                "Odoo offers a wide range of modules covering various functional areas, including:",
              answer1: "- CRM (Customer Relationship Management)",
              answer2: "- Sales",
              answer3: "- Inventory Management",
              answer4: "- Manufacturing",
              answer5: "- Accounting",
              answer6: "- Human Resources (HR)",
              answer7: "- Project Management",
              answer8: "- E-commerce",
              answer9: "- Point of Sale (POS) and many more",
            },
            {
              question: "What is involved in the implementation of Odoo?",
              answer:
                "The implementation of Odoo typically involves several key steps, including:",
              answer1:
                "- Requirement Analysis: Assessing business needs, processes, and requirements to determine the scope of the implementation.",
              answer2:
                "- Configuration: Configuring Odoo modules, workflows, and settings to align with business processes and requirements.",
              answer3:
                "- Data Migration: Importing existing data from legacy systems or spreadsheets into Odoo, ensuring data accuracy and completeness.",
              answer4:
                "- Customization: Developing customizations, enhancements, or integrations to extend Odoo functionality and meet specific business needs.",
              answer5:
                "- Training: Providing training and user adoption programs to educate employees on how to use Odoo effectively.",
              answer6:
                "- Testing: Conducting thorough testing and quality assurance to ensure that Odoo meets functional, performance, and usability requirements.",
              answer7:
                "- Deployment: Deploying Odoo in the production environment and providing ongoing support and maintenance as needed.",
              answer8: "",
              answer9: "",
            },
            {
              question: "How long does it take to implement Odoo?",
              answer:
                "The duration of an Odoo implementation can vary depending on factors such as the scope of the project, complexity of business processes, customization requirements, and organizational readiness. Typically, implementations can range from a few weeks to several months, with phased approaches to rollout and adoption.",
              answer1: "",
              answer2: "",
              answer3: "",
              answer4: "",
              answer5: "",
              answer6: "",
              answer7: "",
              answer8: "",
              answer9: "",
            },
            {
              question: "How can I ensure a successful Odoo implementation?",
              answer:
                "To ensure a successful Odoo implementation, consider the following best practices:",
              answer1:
                "- Define clear objectives, goals, and success criteria for the implementation project.",
              answer2:
                "- Engage stakeholders and obtain buy-in from key decision-makers across the organization.",
              answer3:
                "- Conduct thorough requirement analysis to understand business needs and processes.",
              answer4:
                "- Plan for adequate training, change management, and user adoption programs to support organizational readiness.",
              answer5:
                "- Work closely with experienced Odoo implementation partners or consultants with expertise in your industry and business processes.",
              answer6:
                "- Establish clear communication channels, project milestones, and accountability mechanisms to monitor progress and address issues promptly.",
              answer7: "",
              answer8: "",
              answer9: "",
            },
            {
              question: "Where can I get assistance with Odoo implementation?",
              answer:
                "Organizations can seek assistance with Odoo implementation from certified Odoo partners, consultants, and solution providers. These professionals offer expertise in Odoo implementation, customization, training, and support services tailored to the specific needs of each organization.",
              answer1: "",
              answer2: "",
              answer3: "",
              answer4: "",
              answer5: "",
              answer6: "",
              answer7: "",
              answer8: "",
              answer9: "",
            },
          ]}
          title="We thought you might have questions"
        />
        <div className="faq-dark-banner">
          <h2>Ready to Implement Odoo for Your Business?</h2>
          <p className="faq-banner-subtitle">
            Take the guesswork out of ERP implementation. Our certified Odoo team delivers tailored configurations, seamless integrations, and hands-on support — so your go-live is smooth and your team is ready from day one.
          </p>
          <button className="faq-banner-cta" onClick={() => setIsModalVisible(true)}>
            Connect with us <span>&#8594;</span>
          </button>
        </div>
        <InfoModal
          companyIsEnabled
          url="http://185.213.27.237:8066/Email/ContactUs"
          isModalVisible={isModalVisible}
          handleOk={() => setIsModalVisible(false)}
          handleCancel={() => setIsModalVisible(false)}
        />
        <News isAbout={true} career={true} />
      </Layout>
    </div>
  )
}

export default Index
export const query = graphql`
  query OdooImplementationImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Odooimg: file(relativePath: { eq: "Odoobg.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(
      relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }

    RSSImages1: file(relativePath: { eq: "Odoo/MMG-01.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }

    }  
    RSSImages2: file(relativePath: { eq: "Odoo/UnitedGulf-01.webp" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    SecondDivImg: file(
      relativePath: {
        eq: "two-male-colleagues-office-standing-with-laptop 1.png"
      }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
